import { observer } from 'mobx-react';
import React, { PropsWithChildren } from 'react';

import useStores from 'hooks/use-stores';
import Footer from 'main/components/Footer';
import PromoBlock from 'pages/components/PromoBlock';

import useStyles from './styles';

interface Props {
    outerRef?: React.ForwardedRef<HTMLDivElement>;
    innerRef?: React.ForwardedRef<HTMLDivElement>;
    outerClassName?: string;
    innerClassName?: string;
    onOuterScroll?: React.UIEventHandler<HTMLDivElement>;
}

const ContentLayout: React.FC<PropsWithChildren<Props>> = ({
    children,
    outerRef,
    innerRef,
    outerClassName,
    innerClassName,
    onOuterScroll
}) => {
    const { classes, cx } = useStyles();
    const { userStore } = useStores();

    return (
        <div className={cx(classes.outer, outerClassName)} ref={outerRef} onScroll={onOuterScroll}>
            <div className={cx(classes.inner, innerClassName)} ref={innerRef}>
                {children}
                {userStore.hasOnlyFreeLicense || userStore.isAnonymous ? (
                    <PromoBlock className={classes.promo} />
                ) : null}
                <Footer className={classes.footer} />
            </div>
        </div>
    );
};

export default observer(ContentLayout);
